"use strict";
/**
 * @file 地图全景控件
 * @author zhangdongliang
 * @email zdl_1024@163.com
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Control_1 = tslib_1.__importDefault(require("./Control"));
/**
 * 地图全景控件，默认位于地图右下角
 * @visibleName PanoramaControl 地图全景控件
 */
var PanoramaControl = /** @class */ (function (_super) {
    tslib_1.__extends(PanoramaControl, _super);
    function PanoramaControl(props) {
        return _super.call(this, props) || this;
    }
    PanoramaControl.prototype.getControl = function () {
        var defaultOptions = {
            offset: new BMapGL.Size(30, 30),
            anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
        };
        var control = new BMapGL.PanoramaControl(this.getOptions());
        control.setOffset(this.getOptions().offset || defaultOptions.offset);
        control.setAnchor(this.getOptions().anchor || defaultOptions.anchor);
        return control;
    };
    PanoramaControl.prototype.render = function () {
        return null;
    };
    return PanoramaControl;
}(Control_1.default));
exports.default = PanoramaControl;
